<template>
  <section
    id="works-identified"
    class="page-section"
    >
    <div
      class="page-section__header"
      >
      <h3>
        <span
          class="page-section__subheading__text"
          data-overlay-prevent-close="true"
          >
          Works Identified
        </span>
      </h3>
    </div>
    <div
      class="page-section__content"
      >
      <ul
        class="grid"
        data-gtm-object-grid="true"
        >
        <li
          v-for="(work, index) in works"
          :key="work.ID"
          class="grid-item--work--prominent"
          data-overlay-prevent-close="true"
          >
          <a
            class="grid-item__link"
            :href="workUrl(index)"
            data-gtm="from list of objects - clicks object"
            >
            <div
              class="work--in-list__image-container"
              >
              <picture class="picture--start">
                <img
                  class="picture__img--static"
                  draggable="false"
                  :alt="alt(index)"
                  :src="imageUrl(index)"
                  loading="lazy"
                  onerror="window.MoMA.onImageError(this, 1)"
                  >
              </picture>
            </div>
            <div class="work--in-list__caption-container">
              <h3 class="work--in-list__caption">
                <span
                  class="work--in-list__caption__text"
                  v-html="artist(index)"
                  />
                <span
                  class="work--in-list__caption__text"
                  v-html="title(index)"
                  />
                <span
                  class="work--in-list__caption__text"
                  v-html="displayDate(index)"
                  />
              </h3>
            </div>
          </a>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
  export default {
    props: {
      works: {type: Array, required: true }
    },

    methods: {
      workUrl(i) {
        return `/collection/works/${this.works[i].ID}`;
      },

      imageUrl(i) {
        return this.works[i].ImageURL;
      },

      artist(i) {
        return this.works[i].Artist;
      },

      title(i) {
        return this.works[i].Title;
      },

      displayDate(i) {
        return this.works[i].DisplayDate;
      },

      alt(i) {
        let altTag = `${this.artist(i)}. ${this.title(i)}. ${this.displayDate(i)}`;
        let div = document.createElement("div");
        div.innerHTML = altTag;
        return  div.textContent || div.innerText || "";
      },
    },
  };
</script>

